import React, { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";

export default function Profile() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", mobile: user?.mobile || "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/auth/profile", form); updateUser(data.user); toast.success("Profile updated"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  const changePw = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/auth/change-password", pw); updateUser(data.user); setPw({ current_password: "", new_password: "" }); toast.success("Password changed"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-lg">
      <h1 className="font-heading text-2xl font-bold mb-6">Profile</h1>
      <form onSubmit={save} className="card-surface p-6 space-y-4 mb-6">
        <div><label className="text-sm text-content-secondary">Name</label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 bg-ink border-line" data-testid="profile-name" /></div>
        <div><label className="text-sm text-content-secondary">Email</label><Input value={user?.email} disabled className="mt-1 bg-ink border-line opacity-60" /></div>
        <div><label className="text-sm text-content-secondary">Mobile</label><Input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} className="mt-1 bg-ink border-line" data-testid="profile-mobile" /></div>
        <Button disabled={busy} className="btn-ember rounded-full" data-testid="profile-save">Save changes</Button>
      </form>
      <form onSubmit={changePw} className="card-surface p-6 space-y-4">
        <h3 className="font-heading font-semibold text-sm">Change password</h3>
        <Input type="password" required placeholder="Current password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="bg-ink border-line" />
        <Input type="password" required placeholder="New password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="bg-ink border-line" />
        <Button disabled={busy} variant="outline" className="rounded-full border-line">Update password</Button>
      </form>
    </div>
  );
}
